<template>
  <div class="mapPage" :class="{'hashead':!isPC}">
    <LeaveTel ref="LeaveTel"></LeaveTel>
    <Header v-if="isPC"></Header>
    <WapHeader :title="name" v-if="!isPC" :showhome="true"></WapHeader>
    <Maps class="mapbox" v-if="mapVO" :bcenter="mapVO" :nameShow="true" @leaveClick="leaveClick"></Maps>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Maps from '@/components/Maps'
import LeaveTel from '@/components/public/LeaveTel'
export default {
  name:'MapDetail',
  components:{
    'Header': Header,
    'WapHeader':WapHeader,
    'Maps':Maps,
    'LeaveTel':LeaveTel,
  },
  data () {
    return{
      isPC:this.$store.state.isPC,
      estateVO:[],
      mapVO:'',
      name:'',
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    this.getEstateDetail(this.$route.query.estateId);
  },
  methods:{
    getEstateDetail:function(id){
      this.$http.get('/api/estate/getEstateDetail?estateId='+id).then((response)=>{
        this.estateVO = response.data.result.qtEstateVO;
        this.mapVO = response.data.result.mapVO;
        this.name = this.estateVO.name;
      }).catch((response)=>{
        console.log(response)
      })
    },
    leaveClick(index){
      this.$refs.LeaveTel.leaveClick(index,this.estateVO.pkId,this.estateVO.name,'楼盘');
    },
  }
}
</script>

<style scoped>
.mapPage{position:absolute;left:0;right:0;top:0;bottom:0;}
.mapbox{background:#f5f3f0;overflow:hidden;}
.mapPage>>>.mapwrap{height:100%;}
.mapPage>>>.mapwrap{margin-top:0;}
.mapPage>>>.leave-box{margin-top:20px;}
@media (max-width:768px){
  .mapbox{height:100%;}
  .mapPage{padding-bottom:165px;}
  .mapPage>>>.maptypewrap{position:absolute;bottom:0;left:0;right:0;background:#fff;padding:3px 15px 15px;}
}

@media (min-width:769px){
  .mapbox{position:absolute;top:132px;left:0;right:0;bottom:0;}
  .maptype_bottom{position:absolute;right:30px;bottom:30px;background:#fff;border-radius:5px;box-shadow:0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);border:1px solid #999;width:300px;padding:10px 20px 20px;}
  .mapPage>>>.maptypewrap{top:auto;bottom:30px;}
}
</style>


// WEBPACK FOOTER //
// src/components/MapDetail.vue